import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HOUDINI_inventoryQuery'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HOUDINI_inventoryQueryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HOUDINI_inventoryQueryStore",
			variables: true,
		})
	}
}

export async function load_HOUDINI_inventoryQuery(params) {
  await initClient()

	const store = new HOUDINI_inventoryQueryStore()

	await store.fetch(params)

	return {
		HOUDINI_inventoryQuery: store,
	}
}
